<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-unfold`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 4a1 1 0 011 1v38a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1h2zm-25.628 6.482l.094.083 1.414 1.414a1 1 0 01.083 1.32l-.083.094-8.607 8.605H35a1 1 0 01.993.884l.007.116v2a1 1 0 01-.883.994l-.117.006H10.271l8.61 8.609a1 1 0 01.082 1.32l-.083.094-1.414 1.414a1 1 0 01-1.32.083l-.094-.083L3.324 24.707a1 1 0 01-.083-1.32l.083-.094 12.728-12.728a1 1 0 011.218-.152l.102.069z"/></svg>
</template>
<script>

export default {
  name: 'IconUnfold',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
